import { useRef } from 'react';
import { LogIn } from 'lucide-react';
import { useGoogleSignInButton } from './use-google-identity';

/**
 * The guest account menu's single entry: the official Google button, shown
 * as-is. It used to be rendered invisibly over a custom "Sign in" row, but
 * GIS serves the button in an iframe with occlusion detection and silently
 * drops clicks while the button is hidden — a server-side tightening of that
 * check is what killed prod sign-in on 2026-07-08, so the container must stay
 * fully visible. The plain row underneath is the loading placeholder (and the
 * whole entry, inert, when the client ID is unconfigured).
 */
export function SignInMenuItem({ onCredential }: { onCredential: (credential: string) => void }) {
  const containerRef = useRef<HTMLDivElement>(null);
  useGoogleSignInButton({ containerRef, onCredential });

  return (
    <div role="menuitem" className="relative flex h-10 w-full items-center gap-2 px-3 text-sm">
      <LogIn className="size-4" />
      Sign in
      {/* Not aria-hidden: once rendered, Google's button is the row's real
          focusable control. */}
      <div ref={containerRef} className="absolute inset-0" />
    </div>
  );
}
